const formatPrice = (price: number, currency: string, language: string | string[]): string => {
  const formatter = new Intl.NumberFormat(language, {
    style: 'currency',
    currency,
  });

  const formattedPrice = formatter.format(price).replace(/\D00(?=\D*$)/, '');

  // fixes DSXP-936, in the long run formatting should be handled by B.E. ideally...
  if (language === 'us') {
    return formattedPrice.replace('US$', '$');
  }

  return formattedPrice;
};

const getNumber = (price: string | number): number => {
  return typeof price === 'number' ? price : parseInt(price, 10);
};

const convertToCents = (price: string | number): number => {
  return getNumber(price) * 100;
};

const convertFromCents = (priceInCents: string | number): number => {
  return getNumber(priceInCents) / 100;
};

export { formatPrice, convertToCents, convertFromCents };
